"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HodGetToKnowUsData = void 0;
const infrastructure_1 = require("../../../infrastructure");
class HodGetToKnowUsData extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    isComplete() {
        return true;
    }
    toPlain() {
        return { ...this };
    }
}
exports.HodGetToKnowUsData = HodGetToKnowUsData;
//# sourceMappingURL=HodGetToKnowUsData.js.map